import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Typography, TextField, Avatar, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useHistory } from 'react-router-dom';

const CaliforniaPropCommentsReplyPage = () => {
   const [comment, setComment] = useState(null);
   const history = useHistory();
   const [title, setTitle] = useState('');
   const [open, setOpen] = useState(false);
   const [content, setContent] = useState('');
   const [replyText, setReplyText] = useState("");

   const { id, commentId } = useParams();
   const [calProp, setCalProp] = useState(null);


   useEffect(() => {
   axios.get(`/CaliforniaProposition50`)
       .then(res => setCalProp(res.data))
       .catch(err => console.error("Error loading bill", err));
   }, [id]);


   useEffect(() => {
   const fetchComment = async () => {
   try {
       const res = await axios.get(`/calProp/${id}/commentReplies/${commentId}`);
       setComment(res.data);
   } catch (err) {
       console.error("Error fetching comment:", err);
   }
   };


   fetchComment();
   }, [commentId]);




   const handleSubmit = async () => {
   try {
       await axios.post('/api/govPosts', {
       title,
       content,
       topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
       });
       setOpen(false);
       setTitle('');
       setContent('');
       alert('Post created!');
   } catch (err) {
       console.error('Failed to create post', err);
   }
   };


   const toggleCommentVote = async (commentId) => {
       try {
           // hit backend endpoint that toggles a vote
           const res = await axios.post(`/calPropComments/${commentId}/upvote`);


           setComment(prev => ({
               ...prev,
               upvotes: res.data.upvotes,
               voted: res.data.voted
           }));
       } catch(err) {
           console.error("Vote error", err);
       }
   };
       // Recursively update a reply at any depth
   function updateReplyRecursive(replies, replyId, newData) {
       return (replies || []).map((r) => {
       if (r._id === replyId) {
           return { ...r, ...newData }; // update this reply
       }
       return {
           ...r,
           replies: updateReplyRecursive(r.replies, replyId, newData), // recurse
       };
       });
   }


   const toggleReplyVote = async (replyId) => {
       try {
       const res = await axios.post(`/calProp/${id}/commentReplies/${replyId}/upvote`);
       const { replyUpvotes, replyVoted } = res.data;


       setComment((prev) => {
           if (!prev) return prev;


           // Case A: this comment itself is the reply
           if (prev._id === replyId) {
           return {
               ...prev,
               replyUpvotes,
               replyVoted,
           };
           }


           // Case B: it's somewhere in prev.replies (any depth)
           return {
           ...prev,
           replies: updateReplyRecursive(prev.replies, replyId, {
               replyUpvotes,
               replyVoted,
           }),
           };
       });
       } catch (err) {
       console.error("Reply vote error", err);
       }
   };
       console.log(comment);
   const handleReplySubmit = async () => {
       if (!replyText.trim()) return;


       try {
       const res = await axios.post(`/calProp/comments/${comment._id}/replies`, {
           text: replyText
       });


       setComment(prev => ({
       ...prev,
       replies: [
           ...(prev.replies || []), res.data]
       }));


       setReplyText("");
       } catch (err) {
       console.error("Reply error", err);
       }
   };
   //console.log(comment);
   if (!comment) return <Typography>Loading...</Typography>;


   const isTopLevel = calProp?.comments?.some(c => c._id === comment._id);


   function addReplyRecursive(comment, targetId, newReply) {
   // if this comment/reply matches the target, append the new reply
   if (comment._id === targetId) {
       return {
       ...comment,
       replies: [...(comment.replies || []), newReply]
       };
   }


   // otherwise, dive into nested replies
   return {
       ...comment,
       replies: comment.replies?.map(r => addReplyRecursive(r, targetId, newReply)) || []
   };
   }


   const handleReplyCommentSubmit = async (targetId) => {
   if (!replyText.trim()) return;
   try {
   const res = await axios.post(`/calProp/${id}/replyComments/${targetId}/replies`, {
   text: replyText
   });


   const newReply = res.data;


   // update the state recursively
   setComment(prev => addReplyRecursive(prev, targetId, newReply));




   setReplyText("");
   } catch (err) {
   console.error("Reply error", err);
   }
   };




   return (
   <div
           style={{
               padding: '20px',
               backgroundColor: '#FFFDF8',
               minHeight: '100vh',  // ensures it covers the full viewport height
               boxSizing: 'border-box', // ensures padding doesn't affect layout
           }}
       >


           <div style={{ width: '200px' }}></div>




           {/* Centered Buttons */}
           <Box
               display="flex"
               justifyContent="center"
               alignItems="center"
               gap={2}
               flexWrap="wrap"
               sx={{
                   mt: 4,
                   mb: 4,
               }}
                   >
                       <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333",
                           color: "#333333",   
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/b/b1')}
                   >
                       Enacted Laws
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333",
                           color: "#333333",   
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/b/b2')}
                   >
                       U.S. Congressional Bills
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333",
                           color: "#333333",   
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/CaliforniaBills')}
                   >
                       California Legislature Bills
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333",
                           color: "#333333",   
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/b/b2')}
                   >
                       State Propositions
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333",
                           color: "#333333",   
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => setOpen(true)}
                   >
                       Propose
                   </Button>


       </Box>
   <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
       >
       {/* original comment */}
       <Box display="flex" alignItems="flex-start" gap={1}>
       <Avatar
           src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
           sx={{ width: 62, height: 62 }}
       />
       <Box>
           <Typography variant="h6" fontWeight="bold">
           {comment.author?.first_name} {comment.author?.last_name}
           </Typography>
           <Typography variant="body2" color="text.secondary">
           @{comment.author?.username}
           </Typography>
           <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
           {comment.text}
           </Typography>
           <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
           {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
           </Typography>
       </Box>
       </Box>




       <Box mt={2} display="flex" alignItems="center" gap={1}>
                           <Button
                               size="small"
                               variant={
                                   isTopLevel
                                   ? (comment.voted ? "contained" : "outlined")
                                   : (comment.replyVoted ? "contained" : "outlined")
                               }
                               onClick={(e) => {
                                   e.stopPropagation();
                                   if (isTopLevel) {
                                   toggleCommentVote(comment._id);
                                   } else {
                                   toggleReplyVote(comment._id);
                                   }}
                               }
                           >
                               ▲ {isTopLevel
                                   ? (comment.voted ? "Unvote" : "Upvote")
                                   : (comment.replyVoted ? "Unvote" : "Upvote")}
                           </Button>
                           <Typography variant="body2">
                               {isTopLevel ? comment.upvotes : comment.replyUpvotes} upvotes
                           </Typography>
                       </Box>
   </Box>
   {/* Comment Form */}
       <Box
           p={2} // padding inside box
           my={2} // vertical margin between posts
           border="1px solid #ccc" // light grey border
           borderRadius="8px" // rounded corners
           sx={{
               position: "relative",
               maxWidth: 900, // limit width
               mx: "auto", // center horizontally
               my: 2, // vertical spacing between each post
           }}
       >
       <TextField
           fullWidth
           multiline
           rows={2}
           placeholder="Engage in intellectual discouse..."
           value={replyText}
           onChange={(e) => setReplyText(e.target.value)}
       />
       <Button
           variant="outlined"
           sx={{ mt: 1 }}
           onClick={(e) => {
           e.stopPropagation();
           if (isTopLevel) {
               handleReplySubmit(comment._id);
           } else {
               handleReplyCommentSubmit(comment._id);
           }
           }}
       >
           Reply
       </Button>
       </Box>
       {/* replies */}
       {comment.replies && comment.replies.length > 0 ? (
           comment.replies.map((reply) => (
           <Box
               p={2} // padding inside box
               key={reply._id}
               onClick={() => history.push(`/calProp/${id}/comments/${reply._id}`)}
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
                   cursor: "pointer",
                   "&:hover": {
                       backgroundColor: "#f9f9f9"
                   }
               }}
       >
           <Box display="flex" alignItems="flex-start" gap={1}>
                           <Avatar
                               src={reply.author?.profileImageUrl || '/default-avatar.jpg'}
                               alt={`${reply.author?.first_name || ''} ${reply.author?.last_name || ''}`}
                               sx={{ width: 62, height: 62 }}
                           />
                           <Box>
                               <Typography variant="subtitle1" fontWeight="bold">
                               {reply.author?.first_name && reply.author?.last_name
                                   ? `${reply.author.first_name} ${reply.author.last_name}`
                                   : 'Unknown Name'}
                               </Typography>
                               <Typography variant="body2" color="text.secondary">
                               @{reply.author?.username || 'unknown'}
                               </Typography>




                               {/* Post content */}
                               <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                   {reply.text}
                               </Typography>




                               {/* Date */}
                               <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                   {`${new Date(reply.created_at).toLocaleString()}, ${reply.replies.length} ${reply.replies.length === 1 ? 'reply' : 'replies'}`}
                               </Typography>




                           </Box>
                       </Box>
              
               <Box mt={2} display="flex" alignItems="center" gap={1}>
                           <Button
                               size="small"
                               variant={reply.replyVoted ? "contained" : "outlined"}
                               onClick={(e) => {
                                   e.stopPropagation();
                                   toggleReplyVote(reply._id)}
                               }
                           >
                               ▲ {reply.replyVoted ? "Unvote" : "Upvote"}
                           </Button>
                           <Typography variant="body2">{reply.replyUpvotes} upvotes</Typography>
                       </Box>
           </Box>
           ))
       ) : (
           <Typography>No replies yet.</Typography>
       )}
   </div>
   );
};




export default CaliforniaPropCommentsReplyPage;
